module.exports = __webpack_public_path__ + "img/mail-dark.fcb168fe.svg";